import { ReactNode, Provider, ReactElement } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { startupQueries } from 'app/agriculture/contexts/RequiredStartupProviders/queries';
import * as Sentry from '@sentry/react';
import { ConfigService } from 'app/config/config.service';

export const LOCAL_STORAGE_TOKEN_KEY = 'ls.currentApiToken';

function AuthComponent({ children }: { children: ReactNode }): ReactElement<Provider<string>> {
    const {
        data: { token, id, name },
    } = useSuspenseQuery(startupQueries.token);

    if (ConfigService.devMode) localStorage.setItem(LOCAL_STORAGE_TOKEN_KEY, token);

    Sentry.setUser({ id, name });

    return <>{children}</>;
}

export { AuthComponent };
